import {logger} from "../log/logger";
import {commonStore} from "../../redux/common/commonStore";
import * as Sentry from "@sentry/react";

/**
 * Helper function for surrounding the passed in function with a try catch.
 * If an error is caught, a redux message will be dispatched so that the
 * @param func
 * @param message - message to be displayed. if not supplied, a default message will be used. NOTE: If message is longer than ~10 words the scrollbar will be displayed
 */
export async function withDisplayErrorToUser<T>(func: () => T | void, message?: string){
  const isAsync = isAsyncFunction(func);

  const logErrorAndDisplayMessage = (e: Error) => {
    const error = e as Error;
    logger.error({ message: JSON.stringify(error) });
    commonStore.setError({ isOpen: true, message: message, debugInfo: [error.message, JSON.stringify(error.stack)]});
  };

  if (isAsync) {
    try {
      await func();
    } catch(e) {
      logErrorAndDisplayMessage(e as Error);
      Sentry.captureException(e);
    }

  } else {
    try {
      func();
    }
    catch(e) {
      logErrorAndDisplayMessage(e as Error);
      Sentry.captureException(e);
    }
  }
}

function isAsyncFunction(fn: Function): boolean {
  const AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
  return fn instanceof AsyncFunction;
}


/**
 * @param message - message to be displayed. if not supplied, error.message will be used. NOTE: If message is longer than ~10 words the scrollbar will be displayed
 * @param stackTrace - array of stacktrace lines to send to support for debugging
 */
export function displayErrorToUser(message?: string, stackTrace?: string[]){
  commonStore.setError({ isOpen: true, message, debugInfo: stackTrace});
}